/* eslint-disable react/no-array-index-key */
import React, { useState, useContext } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { vehicleContext } from '../VehicleProvider';
import isFallback from '../../utils/isFallback';
import LightBoxModal from './LightBoxModal';
import CloseIcon from '../../assets/icons/CloseIcon';
import { Container, ImageButton, Image, MoreImages, IconContainer } from './styles/LightBox.style';
import { VehicleImages } from '../../types';
import { COLORS } from '../../styles/variables';

type InputProps = {
  images?: VehicleImages[] | undefined;
  usedImages?: string[] | null;
  modelName: string | undefined;
  header: string;
  nonAudi: boolean;
  used: boolean;
  hasDealerImages?: boolean;
};

const LightBox: React.FC<InputProps> = ({
  images,
  header,
  modelName,
  nonAudi,
  usedImages,
  used,
  hasDealerImages,
}) => {
  const [showModal, setShowModal] = useState(false);

  const isMobile = useMediaQuery({
    query: '(max-width: 767px)',
  });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1299 });
  const { t } = useTranslation();

  const handleSetShowModal = () => setShowModal(!showModal);
  const { loading } = useContext(vehicleContext);
  const displayImages = images?.length && images?.length > 5 ? images?.slice(0, 4) : images;
  const extraImages = images?.length && images?.length > 5 ? images?.slice(4) : images;
  // const displayImages = images?.slice(0, 4);
  // const extraImages = images?.slice(4);
  const displayUsedImages = usedImages?.slice(0, 4);
  const extraUsedImages = usedImages?.slice(4);
  const fallback = isFallback(header);
  const cardsToShow = isMobile ? 4 : 5;

  if (loading) {
    return (
      <Container data-testid="image-gallery-container">
        {Array.from({ length: cardsToShow })
          .fill(null)
          .map((_, index) =>
            isTablet ? (
              // @ts-ignore
              <SkeletonTheme
                key={index}
                baseColor={COLORS.skeletonColor}
                highlightColor={COLORS.highlightColor}
              >
                <ImageButton>
                  <Skeleton />
                </ImageButton>
              </SkeletonTheme>
            ) : (
              <ImageButton key={index}>
                <Skeleton />
              </ImageButton>
            ),
          )}
      </Container>
    );
  }

  if (!extraImages?.length && !extraUsedImages?.length) return null;

  return (
    <>
      <Container
        fallback={fallback}
        used={used}
        nonAudi={nonAudi}
        hasDealerImages={hasDealerImages}
        data-testid="image-gallery-container"
      >
        {used || nonAudi
          ? displayUsedImages?.map((url) => (
              <ImageButton
                type="button"
                onClick={handleSetShowModal}
                key={Math.random()}
                fallback={fallback}
                used={used}
                nonAudi={nonAudi}
                data-testid="gallery-modal-button"
              >
                <Image src={url.toString()} alt={modelName} data-testid="image" />
              </ImageButton>
            ))
          : displayImages?.map((image) => (
              <ImageButton
                type="button"
                onClick={handleSetShowModal}
                key={Math.random()}
                data-testid="gallery-modal-button"
              >
                <Image
                  src={image.url ? `${image.url}?wid=300` : ''}
                  alt={modelName}
                  data-testid="image"
                />
              </ImageButton>
            ))}
        {!isMobile && ((displayUsedImages?.length && used) || (displayImages?.length && !used)) && (
          <MoreImages onClick={handleSetShowModal} data-testid="gallery-modal-button">
            <IconContainer>
              <CloseIcon />
            </IconContainer>
            {used && extraUsedImages?.length && (
              <p>
                + {extraUsedImages.length} {t('vdpHeader.images')}
              </p>
            )}
            {!used && extraImages?.length && (
              <p>
                + {extraImages.length} {t('vdpHeader.images')}
              </p>
            )}
          </MoreImages>
        )}
      </Container>

      <LightBoxModal
        isOpen={showModal}
        handleIsOpen={handleSetShowModal}
        images={images}
        nonAudiImages={usedImages}
        modelName={modelName}
        nonAudi={nonAudi}
        isUsed={used}
      />
    </>
  );
};

export default LightBox;
